import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { Select } from "../Form";

import { Year, Month, StyledFullDate, StyledDate, StyledFullTime, TimeText } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

import {
    getYearOptions,
    getMonthOptions,
    getDateOptions,
    getHourOptions,
    getMinuteOptions,
} from "./utils";

const DateTime = ({
    date,
    disabled,
    onChange,
}: IProps) => {
    const { formatDate } = useIntl();
    const handleChange = (change: { dateYear?: number, dateDate?: number, dateMonth?: number, dateHour?: number, dateMinute?: number }) => {
        const newDate = new Date(date);
        if (change.dateYear) {
            newDate.setFullYear(change.dateYear);
        }
        if (change.dateMonth !== undefined) {
            newDate.setMonth(change.dateMonth);
        }
        if (change.dateDate) {
            newDate.setDate(change.dateDate);
        }
        if (change.dateHour !== undefined) {
            newDate.setHours(change.dateHour);
        }
        if (change.dateMinute !== undefined) {
            newDate.setMinutes(change.dateMinute);
        }
        onChange(newDate);
    };
    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth();
    const dateDate = date.getDate();
    const dateHour = date.getHours();
    const dateMinute = date.getMinutes();

    return (
        <>
            <StyledFullDate>
                <Year>
                    <Select
                        name="year"
                        value={dateYear}
                        options={getYearOptions()}
                        onChange={e => handleChange({ dateYear: e.target.value, dateDate: 1 })}
                        noDelete
                        disabled={disabled}
                    />
                </Year>
                <Month>
                    <Select
                        name="month"
                        value={dateMonth}
                        options={getMonthOptions(formatDate)}
                        onChange={e => handleChange({ dateMonth: e.target.value, dateDate: 1 })}
                        noDelete
                        disabled={disabled}
                    />
                </Month>
                <StyledDate>
                    <Select
                        name="date"
                        value={dateDate}
                        options={getDateOptions(dateYear, dateMonth, formatDate)}
                        onChange={e => handleChange({ dateDate: e.target.value })}
                        noDelete
                        disabled={disabled}
                    />
                </StyledDate>
            </StyledFullDate>
            <StyledFullTime>
                <Select
                    name="hour"
                    value={dateHour}
                    options={getHourOptions()}
                    onChange={e => handleChange({ dateHour: e.target.value })}
                    noDelete
                    disabled={disabled}
                />
                <TimeText>
                    <FormattedMessage {...messages.hour} />
                </TimeText>
                <Select
                    name="minute"
                    value={dateMinute}
                    options={getMinuteOptions()}
                    onChange={e => handleChange({ dateMinute: e.target.value })}
                    noDelete
                    disabled={disabled}
                />
                <TimeText>
                    <FormattedMessage {...messages.minute} />
                </TimeText>
            </StyledFullTime>
        </>
    );
}

export default DateTime;
